import { z } from 'zod';

/** A translator function (react-i18next's `t`, or an identity fn in tests). */
export type Translate = (key: string) => string;

/**
 * Validation for the login form. Built as a factory so error messages are
 * localized via `t` while staying unit-testable with an identity translator.
 * Output shape matches the `LoginRequest` payload dispatched to the auth thunk.
 */
export function createLoginSchema(t: Translate) {
  return z.object({
    tenant_code: z.string().trim().min(1, t('auth.tenantCodeRequired')),
    email: z
      .string()
      .trim()
      .min(1, t('auth.emailRequired'))
      .email(t('auth.emailInvalid')),
    password: z.string().min(1, t('auth.passwordRequired')),
    remember_me: z.boolean(),
  });
}

export type LoginFormValues = z.infer<ReturnType<typeof createLoginSchema>>;
